import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import { Map, GoogleApiWrapper, InfoWindow, Marker } from 'google-maps-react';
import Loader from './Loader';
import AppHeader2 from './AppHeader2';
import CurrentLocation from './UpdateMap';

const mapStyles = {
    width: '90%',
    height: '300px'
  };


class PlotMap2 extends React.Component {
    constructor(props) {
        //console.log(props);
        super(props);
        this.state = {
            LOADING: true,
            id: props.match.params.id,
            showingInfoWindow: false,  //Hides or the shows the infoWindow
            activeMarker: {},          //Shows the active marker upon click
            selectedPlace: {},          //Shows the infoWindow to the selected place upon a marker
            address: '',
            lat: '',
            long: '',
            CIRCLE: '',
            CIRCLEID: '',
            LOADING: true, 
            Notifications: false,
            delSET: false,
            areas: [],
            selectedAREA: ''
        };
    }

    handleSubmit = (e) => {
        e.preventDefault();

        let err = 0;
        if ($('#frmPlotMap')[0].checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            err++;
        }
        $('#frmPlotMap')[0].classList.add('was-validated');

        if(err==0)
        {
            $('#submitLoading').css('display','block');
            const method = "POST";
            const body = new FormData(this.form);
            //console.log(body);
            var that = this;
            fetch("https://m.donedelivery.in/api/locate_api.php", { method, body })
            .then(function (response) {
                //console.log(response);
                return response.json();
            })
            .then(function (result) {

                //console.log(result);
                //alert(result);
                let del = false;
                let notify = '';
                let areas = [];
                if(result.err!='' && result.err!=undefined && result.err!='undefined')
                {
                    if(result.err=='1') notify = 'ERR';
                    else if(result.err=='2') notify = 'ERR';
                    else if(result.err=='3') notify = 'ERR';
                    else if(result.err=='4') notify = 'Invalid Access Detected';

                    areas = result.areas;
                }

                let circle = result.circle;
                if(circle!='' && circle!=undefined)
                {
                    let allowAddressChange = 'Y';
                    let cartCIRCLE = localStorage.getItem('cartCIRCLE');
                    let CIRCLEID = result.circleID;
                    if(cartCIRCLE !== null && cartCIRCLE!=='{}')
                    {
                        if(CIRCLEID!=cartCIRCLE)
                            allowAddressChange = 'N';
                    }

                    if(allowAddressChange=='N')
                    {
                        let search_address = result.search_address;
                        if(search_address!='' && search_address!=undefined)
                        {
                            localStorage.setItem('searchedADDRESS',search_address);
                        }

                        that.setState({ CIRCLE: circle, CIRCLEID:result.circleID, areas:areas });
                        $('#ModalOtherCircleData').modal('show');
                    }
                    else
                    {
                        localStorage.removeItem('addressID');
                        localStorage.setItem('delCIRCLE',circle);
                        localStorage.setItem('delCIRCLE2',result.circleID);
                        localStorage.setItem('GPS','Y');
                        del = true;

                        let search_address = result.search_address;
                        if(search_address!='' && search_address!=undefined)
                        {
                            localStorage.setItem('searchedADDRESS',search_address);
                        }
        
                        that.setState({ Notifications: notify, delSET:del, areas:areas });
                    }                    
                }
                else
                    that.setState({ Notifications: notify, delSET:del, areas:areas });

                $('#submitLoading').css('display','none');
                if(notify!='')
                    $('#ModalAlert').modal('show');
          });
        }
    }

    handlecircleChange = (e) => {
        e.preventDefault();

        var id = $('#selectedArea option:selected').val().trim();
        if(id!='' && id!=0)
        {
            window.location.href = "https://m.donedelivery.in/map2/"+id;
            //window.location.href = "http://localhost:3000/map2/"+id;
            //var that = this;
            //that.setState({ selectedAREA:id});
        }
        else
            alert('Please select area');
    }

    fetchDeliveryAreaCoordiates(mode,id) {
        var that = this;
        fetch('https://m.donedelivery.in/api/deliveryarea_api.php?mode='+mode+'&id='+id,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
                return response.json();
        }).then(function (result) {
            let notify = '';
            let areas = [];
            if(result.err!='' && result.err!=undefined && result.err!='undefined')
            {
                if(result.err=='1') notify = 'ERR';
                else if(result.err=='2') notify = 'ERR';
                else if(result.err=='3') notify = 'ERR';
                else if(result.err=='4') notify = 'Invalid Access Detected';

                areas = result.areas;
            }

            if(result.LAT!='' && result.LAT!=undefined && result.LAT!='undefined' && result.LONG!='' && result.LONG!=undefined && result.LONG!='undefined')
            {
                let address = result.address;
                that.setState({ LOADING:false, address: address, lat: result.LAT, long:result.LONG});                  
            }    
            else
                that.setState({ LOADING:false, Notifications: notify, delSET:del, areas:areas });

            if(notify!='')
                $('#ModalAlert').modal('show');
        });
    }

    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
            //window.location.reload(true);
        }
    }

    componentDidMount() {
        this.fetchDeliveryAreaCoordiates('AREA',this.state.id);
    }

    componentWillReceiveProps(nextProps) {
        window.location.reload();
        //this.setState({ LOADING:true });
        //this.fetchCategoryPage('CATEGORY',nextProps.match.params.id);
    }

    handleGetNewAddressCircle2 = (circle_id,circleID) => {

        localStorage.removeItem('cartCIRCLE');
        localStorage.removeItem('cartData');
        localStorage.removeItem('addressID');
        localStorage.removeItem('cartInstructions');
        localStorage.removeItem('cartVendorID');
        localStorage.removeItem('cartVendorName');
        localStorage.removeItem('cartVendorTypeID');

        localStorage.setItem('delCIRCLE',circle_id);
        localStorage.setItem('delCIRCLE2',circleID);
        localStorage.setItem('GPS','Y');
        this.setState({ delSET:true });
    }
    onMarkerClick = (props, marker, e) =>
        this.setState({
            selectedPlace: props,
            activeMarker: marker,
            showingInfoWindow: true
        });

    handleGetAddress = (address,lat,long) => {
        this.setState({ address: address, lat:lat, long:long})
    }


    handleGetAddress2 = (lat,long) => {
        this.setState({ lat:lat, long:long})
    }

    onMarkerDragEnd = (coord) => {
        const { latLng } = coord;
        const lat = latLng.lat();
        const lng = latLng.lng();
        
        const requestOption = {
            method: 'GET'
        };
  
        //console.log(lat +','+ lng);
        let address = '';
        fetch('https://maps.googleapis.com/maps/api/geocode/json?address='+lat+','+lng+'&key=AIzaSyCTkUK9u3gNBcNnw4PDgbIfXCYDiixfd7U', requestOption)
        .then(res => res.json())
        .then(response => {

          address = response.results[0].formatted_address;
          this.setState({ address: address, lat:lat, long:lng})
          
        })
        .catch(error => {
            console.warn(error);
        });
  
    };

    onClose = props => {
        if (this.state.showingInfoWindow) {
            this.setState({
                showingInfoWindow: false,
                activeMarker: null
            });
        }
    };

    render() { 

        if(this.state.selectedAREA!=='')
        {
            return (<Redirect to={`/map2/${this.state.selectedAREA}`} />);
        }

        if(this.state.delSET==true)
        {
            if(localStorage.getItem('delCIRCLE') && localStorage.getItem('delCIRCLE')!=null)
            {
                return (<Redirect to={'/home'}/>)
            }
        }
        
        /*if(this.state.addressUpdated)
        {
            return (<Redirect to={'/addresses'}/>)
        }*/

        let AppHeaderClass = 'appHeader bg-dark text-light';
        let AppHeaderLeft = 'showLINK';
        let AppHeaderLeftLink = '/addresses';
        let AppHeaderTitle = 'Update Address';
        let AppHeaderRight = '';
        let AppHeaderRightLink = '';
        let AppHeaderSearch = '';

        return (
            <div>
                {this.state.LOADING && <Loader />}
                <AppHeader2 AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} AppHeaderSearch={AppHeaderSearch}/>
                <div id="appCapsule" className="mt-1 p-0">
                    <div className="section full" style={{height: '300px', width: '100%', marginTop: '57px'}}>
                        <div id="map"> {/*onClick={this.onMarkerClick}*/}
                            {this.state.lat!='' && this.state.long!='' &&
                                <CurrentLocation
                                    centerAroundCurrentLocation
                                    google={this.props.google}
                                    handleGetAddress2={this.handleGetAddress2}
                                    initialCenter={{ lat: this.state.lat, lng: this.state.long }}
                                >
                                    <Marker
                                        draggable={true} 
                                        name={this.state.address} 
                                        onDragend={(t, map, coord) => this.onMarkerDragEnd(coord)}/>
                                    <InfoWindow
                                        marker={this.state.activeMarker}
                                        visible={this.state.showingInfoWindow}
                                        onClose={this.onClose}
                                    >
                                        <div>
                                            <h4>{this.state.selectedPlace.name}</h4>
                                        </div>
                                    </InfoWindow>
                                </CurrentLocation>
                            }
                        </div>
                    </div>
                    <form name="frmPlotMap" id="frmPlotMap" ref={el => (this.form = el)} onSubmit={this.handleSubmit} className="needs-validation" noValidate>
                        <input type="hidden" value="PLOT" className="form-control" name="mode" id="mode" required />
                        <input type="hidden" defaultValue={this.state.lat} className="form-control" name="lat" id="lat" required />
                        <input type="hidden" defaultValue={this.state.long} className="form-control" name="long" id="long" required />
                        <div className="section full mb-2">
                            <div className="wide-block wide-block1 pb-1 pt-2 pr-3 pl-3">
                                <div className="form-group boxed">
                                    <div className="input-wrapper">
                                        <label className="label" htmlFor="txtaddress">Delivery Location</label>
                                        <textarea id="txtaddress" name="txtaddress" rows="3" className="square-inputbox form-control square" readOnly autoComplete="off" value={this.state.address} />
                                        <i className="clear-input">
                                            <ion-icon name="close-circle"></ion-icon>
                                        </i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="carousel-button-footer">
                            <div className="row">
                                <div className="col-12 pl-4 pr-4">
                                    <button type="submit" className="text-upper btn btn-danger square btn-md lt-space1 btn-block skip">
                                        <span className="spinner-border spinner-border-sm mr-05" id="submitLoading" style={{display: 'none'}} role="status" aria-hidden="true"></span>
                                        NEXT
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div className="modal fade dialogbox" id="ModalAlert" data-backdrop="static" tabIndex="-1" role="dialog">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-icon text-danger">
                                    <ion-icon name="close-circle"></ion-icon>
                                </div>
                                <div className="modal-body"> 
                                    {this.state.Notifications=='ERR' && 'We dont seem to service your current location yet, Please choose your preferred delivery location'} 
                                    {this.state.Notifications!='ERR' && this.state.Notifications} 
                                    {this.state.Notifications=='ERR' && 
                                        <div className="form-group basic more-locations">
                                            <div className="input-wrapper">
                                                <select className="form-control text-upper btn btn-dark square custom-select" name="selectedArea" id="selectedArea" onChange={this.handlecircleChange}>
                                                    <option value="0">View Available Locations</option>
                                                    {this.state.areas.length>0 &&
                                                        this.state.areas.map((post,i) =>{
                                                            return (
                                                                <option value={post.ID} key={i}>{post.NAME}</option>  
                                                            );                                                             
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="modal-footer">
                                    <div className="btn-inline"> 
                                        <button type="button" className="btn" data-dismiss="modal">Close</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal fade dialogbox" id="ModalOtherCircleData" data-backdrop="static" tabIndex="-1" role="dialog">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">&nbsp;</h5>
                                </div>
                                <div className="modal-body"> Your cart contains items from another location. The cart will be deleted, proceed? </div>
                                <div className="modal-footer">
                                    <div className="btn-inline">
                                        <button className="btn btn-text-success" data-dismiss="modal" onClick={()=>{this.handleGetNewAddressCircle2(this.state.CIRCLE,this.state.CIRCLEID)}}>Yes</button>
                                        <button type="button" className="btn btn-text-danger" data-dismiss="modal">No</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
  
//export default AddAddress2;
export default GoogleApiWrapper({
    apiKey: 'AIzaSyAulaRKToTlt3yoV7VE-XAENWXVhIRrVHs'
})(PlotMap2)


// WEBPACK FOOTER //
// ./src/components/PlotMap2.js